import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import UserStore from '../../stores/UserStore';
import { AutoCompleteRecord } from '@partsbadger/library';

const ContactSwitcher = () => {
    const [contacts, setContacts] = useState<{ id: number; email: string }[]>([]);
    const [default_contact, setDefaultContact] = useState<{ key: string; label: string }>({ key: '', label: '' });

    useEffect(() => {
        if (UserStore.user?.default_contact) {
            setDefaultContact({
                key: UserStore.user.default_contact.id.toString(),
                label: UserStore.user.default_contact.email,
            });
        }
    }, [UserStore.user?.default_contact]);

    useEffect(() => {
        if (UserStore.isVerified) {
            getContacts('');
        }
    }, []);

    const getContacts = async (search: string) => {
        const data = await api.User.getContacts({
            search: search,
        });
        setContacts(data.results);
    };

    const results = contacts.map(contact => {
        return {
            id: contact.id,
            label: contact.email,
        };
    });

    return (
        <AutoCompleteRecord
            placeholder="Search contact"
            handleFetch={search => {
                return getContacts(search);
            }}
            value={default_contact}
            handleSelect={item => {
                UserStore.defaultContact(parseInt(item.key));
                setDefaultContact(item);
            }}
            records={results}
            size="large"
        />
    );
};

export default ContactSwitcher;
